<div class="d-flex flex-column align-items-center w-100 py-8 px-14">
	<img
		class="mb-2"
		ngSrc="/assets/icons/potential-savings/alert-triangle.svg"
		alt="warning icon"
		width="24"
		height="24"
	/>
	<h2 class="fs-xl fw-bold lh-xl mb-2">Switching to EDP mode</h2>

	<p class="text-center fs-lg fw-medium lh-lg mb-8">
		This action can take up to 15 minutes to complete. Please manually refresh the page in about 10 minutes and re-open
		the potential savings calculator. The requested PS mode should appear
	</p>

	<div class="mt-auto d-flex justify-content-center align-items-center">
		<button type="button" class="btn btn-outlined-grey mr-6" (click)="close.emit(false)">Cancel</button>
		<button type="button" class="btn btn-contained" (click)="close.emit(true)">Yes, switch</button>
	</div>
</div>
